// extracted by mini-css-extract-plugin
export var chevron = "_ic-2";
export var dropdownItems = "_ic-0";
export var item = "_ic-1";